/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import {
  Box,
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import Height from "components/height/height";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import { useDispatch } from "react-redux";
import { blank, generateDataList, getScreenRight, showResMsg, validateField } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import { addRoleData, fetchPlanNames, getRoleById, updateRoleData } from "utils/superAdminApi";
import LoadingModal from "../../../components/LoadingModel/loadingModal";



const errMsg = {
  color: `red`,
  fontSize: `11px`,
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};


let fetchedRole;

let routePath = "/roles";



function EditRoles() {
  const { id } = useParams();

  const [controller] = useMaterialUIController();
  const { sidenavColor, darkMode } = controller;
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [roleNameErr, setRoleNameErr] = useState(false);
  const [associatedPlanNameErr, setAssociatedPlanNameErr] = useState(false);
  const [screenName, setScreenName] = useState("Add New Role");
  const [toggleStatus, setToggleStatus] = useState(false);
  const [defaultPlanRole, setDefaultPlanRole] = useState(false);
  const [loading, setLoading] = useState(false);
  const [planNames, setPlanNames] = useState([]);
  const [openPlanDefaultRoleModal, setOpenPlanDefaultRoleModal] = useState(false);
  const [roleInUse, setRoleInUse] = useState(false);
  const [disableColor, setDisableColor] = useState(false);

  const [values, setValues] = React.useState({
    roleName: "",
    roleDescription: "",
    applicableForBusinessUser: "No",
    planID: "",
    defaultPlanRole: "No",
  });

  const [values1, setValues1] = React.useState({
    _id: "",
  });

  const handleChange = (name) => (event) => {
    if (event.target.validity !== undefined && event.target.validity.valid === true) {
      setValues({ ...values, [name]: event.target.value });
    }
    else if (event.target.validity === undefined) {
      setValues({ ...values, [name]: event.target.value });
    }
  };


  useEffect(() => {
    id === undefined ? setScreenName("Add New Role") : setScreenName("Edit Role");
    (async () => {
      getRight();
      fetchPlanNamesData();
      if (id !== undefined) {
        values1._id = id;
        getRoleById(values1, (data) => {
          fetchedRole = data.Result_Output;
          if (fetchedRole) {
            setValues(fetchedRole);
            setRoleInUse(fetchedRole.inUse);
            if (fetchedRole.applicableForBusinessUser === "Yes") {
              setToggleStatus(true);
            } else {
              setToggleStatus(false);
            }

            if (fetchedRole.defaultPlanRole === "Yes") {
              setDefaultPlanRole(true);
            } else {
              setDefaultPlanRole(false);
            }
          }
        }, dispatch)
      }
    }
    )();
  }, [dispatch])



  async function getRight() {
    let right = await getScreenRight("Roles")
    if (right === "Full Access") {
      setDisableColor(false)
    }
    else setDisableColor(true)

  }

  const clearErrorStates = () => {
    setRoleNameErr(false);
    setAssociatedPlanNameErr(false);
  };

  const addNewRoles = async () => {
    let mandateFlag = false;
    clearErrorStates();
    mandateFlag = validateField(values.roleName, setRoleNameErr) || mandateFlag;
    if (toggleStatus) {
      mandateFlag = validateField(values.planID, setAssociatedPlanNameErr) || mandateFlag;
    }
    if (mandateFlag) {
      return;
    }
    const apiFunction = id === undefined ? addRoleData : updateRoleData;
    apiFunction(values, (data) => {
      if (data.Result_Status) {
        showResMsg(id === undefined ? genericMessage.added : genericMessage.updated, 1000, data.Result_Status, navigate, routePath);
      } else {
        showResMsg(data.Result_Message, 2000, data.Result_Status);
      }
    }, dispatch);
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);


  const handleKeyDown = (e) => {
    const inputElement = document.querySelector('.GoogleInput');
    if (e.key === "Enter" && inputElement && inputElement.contains(e.target)) {
      e.preventDefault();
    }
  };



  useEffect(() => {
    if (toggleStatus === true) {
      values.applicableForBusinessUser = "Yes";
    } else {
      values.applicableForBusinessUser = "No";
      // eslint-disable-next-line no-useless-computed-key
      setValues({ ...values, ["planID"]: "" });
      setDefaultPlanRole(false);
    }
  }, [toggleStatus]);

  useEffect(() => {
    if (defaultPlanRole === true) {
      values.defaultPlanRole = "Yes";
    } else {
      values.defaultPlanRole = "No";
    }
  }, [defaultPlanRole]);

  const fetchPlanNamesData = async () => {

    fetchPlanNames(values, async (data) => {

      setPlanNames(await generateDataList(data.Result_Output, "_id", "planName"));
    });
  };



  const handlePlanDefaultRole = async () => {
    if (!defaultPlanRole) setOpenPlanDefaultRoleModal(true);
    else setDefaultPlanRole(!defaultPlanRole);
  };

  const handleCancel = async () => {
    setOpenPlanDefaultRoleModal(false);
  };

  const changePlanDefaultRole = () => {
    setOpenPlanDefaultRoleModal(false);
    setDefaultPlanRole(!defaultPlanRole);
  };


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={3} mb={3}>
        <Grid container spacing={2} style={{ display: "flex", justifyContent: "center" }}>
          <Grid item xs={6} spacing={6}>
            <Card sx={{ boxShadow: "none" }}>
              <MDBox
                mx={2}
                mt={-3}
                mb={1.5}
                py={2}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {screenName}
                </MDTypography>
              </MDBox>
              <Grid container>
                <Grid item xs={6}>
                  <MDBox
                    // pt={4} 
                    //  pb={3} 
                    p={1.6}
                    mb={0.9}
                    px={2}>


                    <MDBox component="form" role="form">
                      <MDBox mb={4} xs={12}>
                        <TextField
                          type="text"
                          label="Role Name"
                          variant="outlined"
                          autoFocus={true}
                          fullWidth
                          inputProps={{
                            pattern: "^[a-zA-Z0-9!@#$%^&*()_+=-{};:'<>,./?]+$",
                            maxLength: 30
                          }}
                          onChange={handleChange("roleName")}
                          value={values.roleName}
                        />
                        {roleNameErr ? <span style={errMsg}>Role Name can't be blank</span> : ""}
                      </MDBox>
                      <MDBox mb={2} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">Associated Plan Name</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            // style={{ minHeight: "3em" }}
                            style={{ minHeight: "44.13px" }}
                            label="Associated Plan Name"
                            value={values.planID}
                            onChange={handleChange("planID")}
                            disabled={!toggleStatus || id !== undefined}

                          >
                            <MenuItem value="">--select plan name</MenuItem>
                            {planNames}
                          </Select>
                          {associatedPlanNameErr ? <span style={errMsg}>Associated Plan Name can't be blank</span> : ""}
                        </FormControl>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Grid>
                <Grid item xs={6}>
                  <MDBox pt={4} pb={3} px={3}>
                    <MDBox component="form" role="form">
                      <MDBox mb={4} xs={12}>
                        <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
                          <MDBox mt={0.5}>
                            <Switch
                              checked={toggleStatus}
                              onChange={() => setToggleStatus(!toggleStatus)}
                              disabled={values.defaultPlanRole === "Yes" || id !== undefined}
                            />
                          </MDBox>
                          <MDBox width="80%" ml={0.5}>
                            <MDTypography variant="button" fontWeight="regular" color="text">
                              Applicable for Business User
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                      <MDBox mb={2}>
                        <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
                          <MDBox mt={0.5}>
                            <Switch
                              checked={defaultPlanRole}
                              disabled={
                                !toggleStatus ||
                                (values.defaultPlanRole === "Yes" && id !== undefined)
                              }
                              onChange={() => handlePlanDefaultRole()}
                            />
                          </MDBox>
                          <MDBox width="80%" ml={0.5}>
                            <MDTypography variant="button" fontWeight="regular" color="text">
                              Associated Plan Default Role
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Grid>
              </Grid>
              <Grid container px={2}
              // style={{ justifyContent: "center" }}
              >
                <Grid item xs={11}>
                  <MDBox mb={2.5} mt={-2.9} xs={12}
                  //  style={{ display: "flex" }}
                  >
                    <TextField
                      type="text"
                      label="Description (optional)"
                      variant="outlined"
                      fullWidth
                      style={{ maxWidth: "900px", width: "109%" }}
                      onChange={handleChange("roleDescription")}
                      value={values.roleDescription}
                      inputProps={{
                        pattern: "^[a-zA-Z0-9. ]+$",
                        maxLength: 200
                      }}
                    />
                  </MDBox>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
        <Grid
          container
          mt={2}
          columnSpacing={{ xs: 2, md: 4, lg: 4 }}
          // columnSpacing={4}
          alignItems="center"
          display="flex"
          justifyContent="center"
        >
          <Grid item xs={12} md={4} spacing={2} lg={1.67}>
            <Link to={"/roles"}>
              <MDButton
                className="btn-block center-container-btn btn-warning btn-back rightSpace"
                color="warning"
                fullWidth
                style={{ width: "165px", height: "40px" }}
              >
                Close
              </MDButton>
            </Link>
          </Grid>
          <Grid item xs={12} md={4} spacing={2} lg={1.67}>
            <MDButton
              onClick={disableColor ? blank : addNewRoles}
              rel="noreferrer"
              variant="gradient"
              className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
              color={disableColor ? "secondary" : "success"}
              fullWidth
              style={{ width: "165px", height: "40px" }}
            >
              {id !== undefined ? <>Update</> : <>Save</>}

            </MDButton>
          </Grid>
        </Grid>
      </MDBox>

      <>

        <Height val={20} />
        <Modal
          open={openPlanDefaultRoleModal}
          onClose={() => handleCancel()}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Card sx={style}>
            <Box >
              <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "black" }}>
                Would you like to set this role as plan default role?
              </Typography>
              <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
                <MDButton color="warning" onClick={() => handleCancel()} style={{ width: "70px" }}>
                  No
                </MDButton>
                &nbsp; &nbsp;
                <MDButton color="success" onClick={changePlanDefaultRole} style={{ width: "70px" }}>
                  Yes
                </MDButton>
              </Grid>
            </Box>
          </Card>
        </Modal>
      </>
      <LoadingModal loading={loading} />
    </DashboardLayout>
  );
}

export default EditRoles;
